import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveKnowledgeAndExperienceMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveKnowledgeAndExperienceParam } from 'api/types/params';

import { parseLegalClient } from './helpers';
import { parseLegalClientKnowledgeAndExperienceParam } from './helpers/parseLegalClientKnowledgeAndExperienceParam';

export const useLegalClientSaveKnowledgeAndExperience = () => {
  const [saveKnowledgeAndExperience, { data, loading, error: apolloError }] =
    useLegalClientSaveKnowledgeAndExperienceMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveKnowledgeAndExperience
      ? parseLegalClient(data.legalClientSaveKnowledgeAndExperience)
      : undefined,
    loading,
    error,
    saveKnowledgeAndExperience: useCallback(
      async (
        id: string,
        params: LegalClientSaveKnowledgeAndExperienceParam
      ) => {
        const input = parseLegalClientKnowledgeAndExperienceParam(params);
        const res = await saveKnowledgeAndExperience({
          variables: { id, input },
        });
        return res.data?.legalClientSaveKnowledgeAndExperience
          ? parseLegalClient(res.data.legalClientSaveKnowledgeAndExperience)
          : undefined;
      },
      [saveKnowledgeAndExperience]
    ),
  };
};
